import SortSelect, { SORT_TYPE } from "Explore/Components/SortSelect";
import styles from "./ConceptAcademicInformation.module.scss";
import { getConceptSurveyPapersById } from "Explore/Services/Concept";
import useExploreInfo from "Hooks/useExploreInfo";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { LoadingListEntityProfile, PaginationList } from "Explore/Components";
import PublicationItem from "Explore/Components/PublicationItem";
import { Empty } from "antd";

const ConceptPaperList = () => {
  const { entity_id: conceptId } = useExploreInfo();
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    totalRows: 0,
  });
  const [sortData, setSortData] = useState({
    orderBy: null,
    order: null,
  });

  const prevFilter = useRef({});

  useEffect(() => {
    const _prevFilter = prevFilter.current;
    if (
      !_.isEqual(_prevFilter, {
        conceptId,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      })
    ) {
      let newPagination = { ...pagination };
      if (
        _prevFilter.conceptId !== conceptId ||
        _prevFilter.rowsPerPage !== pagination.rowsPerPage ||
        _prevFilter.order !== sortData.order ||
        _prevFilter.orderBy !== sortData.orderBy
      ) {
        newPagination.page = 1;
      }

      setData({ data: [], isLoading: true });
      getConceptSurveyPapersById({
        id: conceptId,
        page: newPagination.page - 1,
        rowsPerPage: newPagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      })
        .then((res) => {
          setData({ data: res.results, isLoading: false });
          setPagination({ ...newPagination, totalRows: res.total_count });
        })
        .catch((err) => {
          setData({ data: [], isLoading: false });
          setPagination({ ...newPagination, totalRows: 0 });
        })
        .finally(() => {
          prevFilter.current = {
            conceptId,
            page: newPagination.page,
            rowsPerPage: newPagination.rowsPerPage,
            orderBy: sortData.orderBy,
            order: sortData.order,
          };
        });
    } else {
      prevFilter.current = {
        conceptId,
        page: pagination.page,
        rowsPerPage: pagination.rowsPerPage,
        orderBy: sortData.orderBy,
        order: sortData.order,
      };
    }
  }, [
    conceptId,
    pagination.page,
    pagination.rowsPerPage,
    sortData.orderBy,
    sortData.order,
  ]);
  return (
    <div className={styles["list__wrapper"]}>
      <SortSelect
        sortData={sortData}
        setSortData={setSortData}
        sortType={SORT_TYPE.PUBLICATION}
        hasOrderType
        loading={data.isLoading}
      />

      <LoadingListEntityProfile
        isLoading={data.isLoading}
        component={
          data.data.length > 0 ? (
            data?.data.map((item, index) => {
              return <PublicationItem key={index} data={item} />;
            })
          ) : (
            <Empty description="No Paper Found." />
          )
        }
        componentNum={10}
        rows={2}
        avatar={true}
      />

      <PaginationList
        pagination={pagination}
        setPagination={setPagination}
        pageSizeOptions={[12, 36, 48, 60]}
      />
    </div>
  );
};

export default ConceptPaperList;
